export enum SplitEditor {
  ABSPLIT = 'absplit',
  ATTRIBUTE = 'attribute',
}
